

import { useEffect, useState } from "react";
import '../../../pages/SettingPageuser.css'
import '../../EditModalDam.css'
import { useDispatch, useSelector } from "react-redux";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';

import { useForm } from "react-hook-form";
import { useGlobalContext } from "../../Context";
import apiService from "../../../api/ApiService";
import { isEqual } from "../../EditModalDam";
import { AddStatus } from "../../../redux/slices/warningSlice";
import { Close } from "@mui/icons-material";
const moment=require('moment-jalaali');


const CycleOrderModal=({toggle,penr,iindex})=>{
    console.log(iindex)
    const {currentWarings}=useSelector(state=>state.warning)

    const [valid,setValid]=useState(false)
    const [cycles,setCycles]=useState([])
    const mainProp={toCattleLifeCycleId:penr?.toCattleLifeCycle?.id}
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:mainProp});

    const {openModalls2,isOpenModal2,closeModalls2,isModalSensorCommentOpen,openModallSensorComment,closeModallSensorComment}=useGlobalContext();
   
    const dispatch=useDispatch();
    const allData=watch();
      useEffect(()=>{
        setValid(isEqual(mainProp,allData))
      },[allData])
    
    const getCycleList=async()=>{
        const res=await apiService.getCattleCycleStatusList()
        const filter=res.data.filter(item=>{
            return item?.id!==penr?.toCattleLifeCycle?.id
        })
        setCycles(filter)
    }

    const newOrder=async(data)=>{           
                    
                    const res=await apiService.addOrderCycle(data);
                    dispatch(AddStatus([res.data,...currentWarings]))
                    openModalls2()
    }
    const editOrder=async(data)=>{
        const res=await apiService.editOrderCycle(penr?.id,data)
        const editedList = [
            ...currentWarings.slice(0,iindex),
            res.data,
            ...currentWarings.slice(iindex+1)
          ];
        dispatch(AddStatus(editedList))
        openModallSensorComment()
    }
    
    useEffect(()=>{getCycleList()},[])

    return <div onClick={toggle==='add'?closeModalls2:closeModallSensorComment} className={`modal-overlay ${(toggle==='add'?openModalls2:openModallSensorComment)&&'show-modal'} `}>
        <form onSubmit={handleSubmit(toggle==='add'?newOrder:editOrder)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>

            <div className="editModalDamConHead">
            <AddToPhotosIcon fontSize="large"/>

            <h4 > ترتیب چرخه</h4>
            </div>
            {toggle==='add'&&<div className="SelConn">
            <label for='sele' >از:</label>
        <select id='sele' name='sele' className="selectInp" {...register("fromCattleLifeCycleId",{required:'این مقدار ضروری است'})}>
            
            {
                cycles.map((item,index)=>{
                        return <option key={index} value={item.id}>{item.title}</option>
                })

            }
        </select>
        {errors?.type?.message&&<span className='errMsg'>{errors.type.message}</span>}
            </div>}
            <div className="SelConn">
            <label for='sele' >به:</label>
        <select id='sele' name='sele' className="selectInp" {...register("toCattleLifeCycleId",{required:'این مقدار ضروری است'})}>
            {toggle==='edit'&&<option value={penr?.toCattleLifeCycle?.id}>{penr?.toCattleLifeCycle?.title}</option>}
            {
                cycles.map((item,index)=>{
                        return <option key={index} value={item.id}>{item.title}</option>
                })

            }
        </select>
        {errors?.type?.message&&<span className='errMsg'>{errors.type.message}</span>}
        </div>
        <button disabled={valid} className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default  CycleOrderModal